import React, { Component } from "react";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import "./App.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setView,
  errorResponse,
  fetchTerminate,
  fetchLogin,
  fetchServerVersion,
} from "./actions/index";
import { componentMap } from "./constants/componentMap";
import { customTheme } from "./constants/customTheme";
// import { serverURL } from "./constants/constants";

class App extends Component {
  // constructor(props) {
  //   super(props);
  //   // Subscribe to the eventSource stream, which is where the server publishes events.
  //   this.eventSource = new EventSource(serverURL + "/subscribe_stream"); //SSE event listener
  //   this.eventSource.onopen = () => {
  //     console.log("Connection to server opened.");
  //     this.props.fetchServerVersion();
  //     //check if previous user chose to stay logged in
  //     if (
  //       localStorage.getItem("username") !== null &&
  //       localStorage.getItem("password") !== null
  //     ) {
  //       this.props.fetchLogin(
  //         {
  //           username: localStorage.getItem("username"),
  //           password: localStorage.getItem("password"),
  //         },
  //         true
  //       );
  //     }
  //   };
  //   this.eventSource.onerror = (error) => {
  //     error.message = "Network Error";
  //     if (this.props.viewId !== viewIds.loginPage) {
  //       this.props.errorResponse(error);
  //     }
  //   };
  // }

  // componentWillUnmount() {
  //   this.eventSource.close();
  //   // this.props.fetchTerminate();
  // }
  render() {
    return (
      // Pass the custom theme to all the child components.
      <MuiThemeProvider theme={createMuiTheme(customTheme(this.props.theme))}>
        <CssBaseline />
        {
          // Render the proper top level view based on the current viewId stored in redux:
          React.createElement(componentMap[this.props.viewId], {
            // eventSource: this.eventSource, //Pass the event source as a prop to child components
          })
        }
      </MuiThemeProvider>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { setView, errorResponse, fetchTerminate, fetchLogin, fetchServerVersion },
    dispatch
  );
};

const mapStateToProps = (state) => {
  return {
    viewId: state.view.viewId,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
